module.exports = __webpack_public_path__ + "static/Abacus Dossier aus Sicht des Mitarbeitenden im Portal geöffnet-3eb76b28b2209863e6a8cbc24c74f63d.png";